export default {
    i18n: {
        "Device Name": "デバイス名",
        "day": "日",
        "Device Information": "デバイス情報",
        "handset": "受話器",
        "bluetooth": "Bluetooth",
        "Access Denied.": "アクセス拒否。",
        "Fingerprint": "指紋",
        "Date Time": "日時",
        "name": "名前",
        "tamperAlarm": "タンパーアラーム",
        "Http": "HTTP",
        "Volume": "ボリューム",
        "Card": "カード",
        "minutes": "分",
        "timezone": "タイムゾーン",
        "Are you sure you want to delete this device?": "このデバイスを削除します。よろしいですか？",
        "Attendance Point Name": "勤怠ポイント名",
        "Mac": "Mac",
        "confirmToDeleteIt?": "削除してもよろしいですか？",
        "captureLogs": "キャプチャーログ",
        "Doors": "ドア",
        "All Doors": "すべてのドア",
        "Lock List": "ロックリスト",
        "Link Device Relay": "デバイスリレーをリンク",
        "Added Successfully!": "追加成功！",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "ロックとリレーが連動している場合、リレーがトリガーされるとロックも解錠されます。",
        "Adding...": "追加中...",
        "Please try again 24 hours later.": "24時間後に再試行してください。",
        "Action": "操作",
        "unlock": "解錠",
        "Address": "住所",
        "Owner": "ユーザー",
        "Failed": "失敗",
        "Timeout": "タイムアウト",
        "Response": "応答結果",
        "caller": "発信",
        "receiver": "受信者",
        "doorLogs": "解錠ログ",
        "callHistory": "通話履歴",
        "UID": "SIP",
        "Call Type": "コールタイプ",
        "Code": "コード",
        "User": "ユーザー",
        "Device List": "デバイス一覧",
        "Model": "モデル",
        "Time": "時間",
        "Company": "会社",
        "Property Managers": "プロパティマネージャー",
        "Current Version": "現在のバージョン",
        "indoorMonitor": "室内モニター",
        "guardPhone": "警備電話",
        "close": "クローズ",
        "Success": "成功",
        "URL": "URL",
        "Please select a device.": "デバイスを選択してください。",
        "Password is too weak.": "パスワードの強度が弱いです",
        "Company is required.": "会社を入力してください。",
        "Your account is not activated, please contact your service provider.": "アカウントが有効化されていません。サービスプロバイダーにお問い合わせください。",
        "Language": "言語",
        "Face": "顔",
        "Please set at least one access type.": "アクセスタイプを少なくとも1つ設定してください。",
        "Please contact your service provider to activate this advanced feature.": "プレミアム機能を有効にするには、サービスプロバイダーにお問い合わせください。",
        "Community name": "コミュニティ名",
        "Please enable PM App first.": "先にプロパティアプリを有効にしてください。",
        "Username": "ユーザー名",
        "Change Log": "変更履歴",
        "Assign": "アサイン",
        "Floor": "フロア",
        "Link Device": "リンクデバイス",
        "Accessible Floors": "アクセス可能なフロア",
        "Upgrade": "アップグレード",
        "Function": "機能",
        "callDuration": "通話時間",
        "No": "なし",
        "Verification Code": "認証コード",
        "Expiration Time": "有効期限",
        "PIN": "暗証番号",
        "MAC": "マック",
        "Building": "建物",
        "APT": "部屋番号",
        "ID": "ID",
        "Name": "名前",
        "activities": "履歴情報",
        "Obtain": "取得",
        "call": "電話",
        "Group Call": "グループコール",
        "Delete": "削除",
        "Yes": "はい",
        "Door Release PIN": "ドア解錠用PINコード",
        "Email": "Eメール",
        "Mobile Number doesn\'t exist.": "携帯電話番号は存在しません。",
        "Tips": "ヒント",
        "Password": "パスワード",
        "The end time cannot be earlier than the start time.": "終了時間は、開始時間以降です。",
        "Back": "戻る",
        "File format error.": "ファイルフォーマットエラー",
        "motionDetection": "モーション検知",
        "You are trying too often, please try again in 5 minutes": "試行回数が上限数に超えました。5分後にもう一度お試しください",
        "User name too long.": "ユーザー名が長すぎます。",
        "This MAC address is redirected on RPS.": "該当MACアドレスはRPSでリダイレクトされます。",
        "No Answer": "応答なし",
        "failedToUnlock": "解錠失敗",
        "visitor": "訪問者",
        "yesterday": "昨日",
        "Too large data! Please first export the data before %s first,thanks.": "データサイズオーバーしました！最初に%sの前にデータをエクスポートしてください。",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "未払いの注文があるかをご確認ください。なければ、サービスプロバイダーにお問い合わせください。",
        "lock": "閉扉",
        "open": "オープン",
        "The PersonalAccount is not active.": "個人アカウントが有効化されてません",
        "You cannot link an account that already link other accounts.": "既にリンクされたアカウントはリンクできません",
        "You cannot link multiple property manager accounts under the same installer account.": "同じインストーラアカウントで複数のプロパティマネージャアカウントをリンクすることはできません。",
        "You cannot link to the currently logged in account.": "ログインされているアカウントはリンクできません",
        "nfc": "NFC",
        "Delete Device": "デバイスの削除",
        "date": "日付",
        "Device deleted successfully": "デバイスの削除に成功しました",
        "Failed to delete device": "デバイスの削除に失敗しました",
        "Are you sure you want to cancel?": "キャンセルします、よろしいですか？",
        "Unlimited": "無制限",
        "Password Incorrect.": "パスワードが正しくありません。",
        "deliverySystemVerification": "デリバリー・システムの検証",
        "auto": "自動",
        "Group": "グループ",
        "None": "なし",
        "Upgrading...": "アップグレード中...",
        "amenityReservation": "公共施設予約",
        "idAccess": "IDアクセス",
        "RF Card": "RFカード",
        "exitButton": "開扉ボタン",
        "Please select at least one item.": "少なくとも1つの項目を選択してください。",
        "The ID can contain only digits and letters, up to 32 characters.": "IDは数字とアルファベットのみで、最大32文字まで。",
        "The PIN is not available.": "暗証番号は使用できません。",
        "Change WiFi": "WiFiを変更する",
        "Phone number": "電話番号",
        "Invalid {0}.": "{0}は無効です。",
        "{0} already exists.": "{0}はすでに存在する。",
        "Operation failed!": "操作に失敗した！",
        "Failed to get data.": "データ取得に失敗しました。",
        "You do not have the necessary permissions to perform this operation.": "この操作を実行するために必要な権限がありません。",
        "You can only import one template at a time in the current site.": "現在の物件では、一度に1つのテンプレートしかインポートできません。",
        "Delivery name": "配送名",
        "MAC address not in the MAC library.": "MACライブラリーにないMACアドレス。",
        "Please delete devices under this building.": "このビルの下のデバイスを削除してください。",
        "The start time cannot be later than the end time.": "開始時刻を終了時刻より遅くすることはできない。",
        "emergency action type": "緊急行動タイプ",
        "Only 1000 data items can be imported at a time.": "一度にインポートできるデータは1000件のみ。",
        "The password is too short.": "パスワードが短すぎる。",
        "The data has been updated. Please refresh the page and try again.": "データが更新されました。ページを更新して再度お試しください。",
        "AutoP length must be less 2048 bytes.": "AutoPの長さは2048バイト以下でなければならない。",
        "File Check Failed": "ファイルチェック失敗",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "管理者アカウントのログイン期間が期間切れました。サービスプロバイダに連絡してください",
        "iqPinVerificationFailed": "IQ PIN認証失敗",
        "accountBlacklisted": "アカウントはブラックリストに追加されました",
        "outsideAuthorizedTime": "許可期間外",
        "network group": "ネットワークグループ",
        "Company name": "会社名",
        "Group name": "グループ名",
        "relay": "リレー",
        "motionTime": "モーションタイム",
        "motionType": "モーションタイプ",
        "postalCode": "郵便番号",
        "floor format": "フロアフォーマット",
        "mobilePhone": "モバイルフォン",
        "time format": "タイムフォーマット",
        "security relay": "セキュリティリレー",
        "Param": "パラメータ",
        "Offline Code": "オフラインコード",
        "Add akubela Smart Locks": "Akubelaスマートロックを追加してください",
        "Module Version": "モジュールバージョン",
        "Lock Body Version": "ロック本体バージョン",
        "Available Version": "利用可能なバージョン",
        "Please wake up the lock screen and then upgrade.": "ロック画面を起動してからアップグレードしてください。",
        "This process will take some time, please be patient.": "該当プロセスは少々お時間かかります。お待ちください",
        "Please confirm that the WiFi network is functioning properly.": "WIFIネットワークが利用可能であることを確認してください",
        "Please wake up the lock screen.": "ロック画面をウェイクアップ",
        "This lock has already been added to another apartment.": "該当ロックは別のアパートに追加されました",
        "This lock has already been added to the apartment.": "このロックは既に該当アパートに追加されました",
        "Pin Code": "PINコード",
        "Too many failed attempts, please try again in a few minutes.": "試す回数が多すぎます。数分後でまた試してください。",
        "Login Account": "ログインアカウント",
        "Same account cannot login in different ins.": "同じアカウントは別のインストーラアカウントにログインできません",
        "Lock Name": "ロック名",
        "Smart Locks": "スマートロック",
        "Add Smart Lock": "スマートロック追加",
        "The selected duration cannot be more than one year.": "選択された期間は1年以上することができません",
        "The end time of the break time cannot be later than the end work time.": "休憩時間の終了時刻は、勤務終了時刻より後にすることはできません",
        "The start time of the break time cannot be earlier than the start work time.": "休憩時間の開始時刻は、勤務開始時刻より前にすることはできません。",
        "The end time of the valid check time cannot be earlier than the end work time.": "有効な終了時刻は、勤務終了時刻より前にすることはできません",
        "The start time of the valid check time cannot be later than the start work time.": "有効な開始時刻は、勤務開始時刻より後にすることはできません",
        "Deleting failed. The timetable is used by a shift.": "削除に失敗しました。タイムテーブルはシフトで使用中です。",
        "Deleting failed. The shift is in use.": "削除が失敗しました。該当シフトは使用されてます",
        "Deleting failed. The leave type is in use.": "削除が失敗しました。該当休暇タイプは使用されてます",
        "Valid time conflicts with an existing schedule.": "有効時間が既存のスケジュールと重複しました",
        "The timing for multiple schedules must not coincide.": "複数のスケジュールの時間が重ならないようにしてください",
        "Attendance Log": "勤怠記録",
        "Added Failed!": "追加に失敗しました！",
        "Setting WiFi": "WIFI設定",
        "License Plate": "ナンバープレート",
        "key": "キー",
        "IQ Offline.": "IQオフライン",
        "{0}Unlock": "{0} 解錠",
        "automatically": "自動的",
        "manually": "手動的",
        "Video Storage": "ビデオ保存領域",
        "Device(s) for Video Storage": "ビデオ保存用デバイス",
        "The amount of exported data is too large. Please export it in batches.": "エクスポートするデータ量が多すぎます。バッチごとにエクスポートしてください",
        "Auto-record video when door unlocks": "ドアの解除時に自動録画",
        "Auto-record video during calls": "通話中に自動録画",
        "Manual video recording in monitoring": "モニタリング中の手動ビデオ録画",
        "Saved for 30days/60days/90days": "30日/60日/90日間保存",
        "To subscribe, please contact your provider for activation.": "サブスクリプションには、プロバイダーに連絡してアクティベーションを行ってください。",
        "Saved for {0}days": "{0}日間保存",
        "Subscribed Plan": "サブスクリプションプラン",
        "Supported Devices: {0}": "サポート可能なデバイス：{0}",
        "{0}Lock": "{0}ロック",
        "Video Saving": "ビデオ保存",
        "Download Completed!": "ダウンロードが完了しました！",
        "Fail to download.": "ダウンロードできませんでした。",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "削除に失敗しました！プロパティマネージャーがRentManagerの顧客にバインドされています。まず削除してください。",
        "No log to be exported.": "エクスポートするログがありません。",
        "capture&Video": "スクリーンショット＆動画",
        "packageDetection": "パッケージ検出",
        "Time format is invalid.": "時間フォーマットが無効です。",
        "No permission to export logs of this type.": "該当種類のログをエクスポートする権限がありません。",
        "Project type is invalid.": "プロジェクトタイプが無効です。",
        "Salto Account Blocked.": "Saltoアカウントがブロックされています。",
        "Remote open not in access group.": "リモートオープンはアクセスグループに含まれていません。",
        "SIP Account required.": "SIPアカウントが必要です。",
        "The PIN must be {0} digits.": "PINコードは{0}桁でなければなりません。",
        "gatewayConnectionUnavailable": "ゲートウェイ接続が利用できません。",
        "Invalid Username or Password": "ユーザー名またはパスワードが無効です",
        "Account already linked to another user.": "アカウントは既に他のユーザーにリンクされています。",
        "The account has been added by another user.": "このアカウントは他のユーザーによって追加されました。",
        "Failed to add. This user already has 5 license plates.": "追加できません。このユーザーはすでに5枚のナンバープレートを追加しました。",
        "Please at least select a door.": "少なくとも1つのドアを選択してください。",
        "UHF Card": "UHFカード",
        "personnel": "人員",
        "Parking Lot Name": "駐車場名",
        "Controlled Relay": "制御リレー",
        "No Permission": "許可なし",
        "Please ensure that all doors in the project are activated at the same time.": "プロジェクト内のすべてのドアが同時に作動するようにしてください。",
        "gatewayBusy": "ゲートウェイビジー",
        "Please set the perimeter door group first.": "まず境界ドアを設定してください。",
        "Please ensure that all doors in the project are renewed at the same time.": "プロジェクト内のすべてのドアを同時に更新契約してください",
        "When lockdown is on, the controlled relay cannot be modified.": "ロックダウン中は、制御されたリレーを変更できません。",
        "DetectionLogs": "検出ログ",
        "packageIn": "パッケージイン",
        "packageOut": "パッケージアウト",
        "View Progress": "進捗を表示",
        "Check if the WiFi is operating on the 2.4GHz band.": "WiFiが2.4GHz帯で動作しているか確認してください。",
        "Verify that the WiFi password is correct.": "WiFiのパスワードが正しいか確認してください。",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "ホットスポットの設定時に正しいデバイスのホットスポットに接続していることを確認してください。",
        "Offline Code Unlock": "オフラインコードアンロック",
        "Salto Token Expired.": "Saltoトークンの有効期限が切れています。",
        "Lock Offline": "ロックオフライン",
        "identity information! Please login again": "本人情報です！もう一度ログインしてください",
        "Email is required.": "メールアドレスは必須です。",
        "Mobile number is required.": "携帯番号は必須です。",
        "You can\'t make payments for offices in different time zones.": "異なるタイムゾーンのオフィスに対する支払いはできません。",
        "The current scheduling staff exceeds 200 people.": "現在、シフトに入っているスタッフは200人を超えています。",
        "param": "パラメータ",
        "Invalid UserName or Password": "ユーザー名またはパスワードが無効です",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "あなたのSalto KSアカウントには、ロックの名前を変更する権限がありません。",
        "Owner is required.": "所有者が必要です。",
        "Office is required.": "オフィスが必要です。",
        "PIN or RF Card is required.": "PINまたはRFカードが必要です。",
        "RF card": "RFカード",
        "Personnel is required.": "人員が必要です。",
        "email address": "メールアドレス",
        "mobile number": "携帯番号",
        "The length must be less than 32 characters.": "長さは32文字未満でなければなりません。",
        "The length must be less than 256 characters.": "長さは256文字未満でなければなりません。",
        "Access Group is required.": "アクセスグループが必要です。",
        "Device is required.": "デバイスが必要です。",
        "Admin is required.": "管理者が必要です。",
        "Mobile number": "携帯番号",
        "schedules": "スケジュール",
        "Timetable name": "タイムテーブル名",
        "Shift name": "シフト名",
        "Leave type": "休暇種類",
        "recheck in time": "再チェックイン時間",
        "recheck out time": "再チェックアウト時間",
        "The building name": "建物名",
        "Building is required.": "建物が必要です。",
        "selection, The same reader cannot be set for both entry and exit": "選択、入口と出口に同じリーダーを設定することはできません",
        "Door number": "ドア番号",
        "door input cannot be selection duplicated.": "ドア入力は重複して選択できません。",
        "Group is required.": "グループが必要です。",
        "Title can contain up to 32 characters.": "タイトルは32文字まで入力できます。",
        "Content can contain up to 1024 characters.": "コンテンツには最大1024文字まで含めることができます。",
        "Content can contain up to 64 characters.": "内容は最大64文字まで入力できます。",
        "Report is required.": "報告が必要です。",
        "ID is required.": "IDが必要です。",
        "The office does not exist.": "そのオフィスは存在しません。",
        "Office name": "オフィス名",
        "The Temp Key does not exist.": "一時的なキーが存在しません。",
        "autolock time": "自動ロック時間",
        "The User does not exist.": "ユーザーが存在しません。",
        "The Installer does not exist.": "インストーラーが存在しません。",
        "The Project does not exist.": "プロジェクトは存在しません。",
        "The Distributor does not exist.": "代理店は存在しません。",
        "The Community Device does not exist.": "コミュニティデバイスは存在しません。",
        "The Property Manager does not exist.": "プロパティマネージャーは存在しません。",
        "The Sub Distributor does not exist.": "サブディストリビューターは存在しません。",
        "The Single Slave does not exist.": "単住戸のサブアカウントは存在しません。",
        "The Property Manager EndUser does not exist.": "プロパティマネージャーのエンドユーザーは存在しません。",
        "The Family Member does not exist.": "その家族メンバーは存在しません。",
        "Set Failed!": "設定に失敗しました！",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "30分間に10回のアクセスコードリクエスト上限に達しました。後ほど再度お試しください。",
        "This Email doesn\'t exist.": "このメールアドレスは存在しません。",
        "detection type": "検出タイプ",
        "Device UUID": "デバイスUUID",
        "smart lock device": "スマートロックデバイス",
        "You are trying too often, please try again in 5 minutes.": "操作が頻繁すぎます。5分後にもう一度お試しください。",
        "You can only import one file at a time. Please wait for the current import to finish.": "一度にインポートできるファイルは一つだけです。現在のインポートが完了するまでお待ちください。",
        "NVR Name": "NVR名",
        "NVR Address": "NVRアドレス",
        "Stay Alarm": "滞在アラーム",
        "Happended On": "発生日時",
        "Edit Milesight NVR": "Milesight NVRの編集",
        "Add Milesight NVR": "Milesight NVRの追加",
        "Auto-record video on motion detection, package detection": "モーション検知・荷物検知時に自動でビデオ録画",
        "A 7-day free trial is included with your subscription.": "ご契約には7日間の無料トライアルが含まれています。",
        "For service renewal, please reach out to your provider.": "サービスの更新は、サービスプロバイダーにご連絡ください。",
        "Allow the Property Manager to view recorded videos": "管理者が録画映像を閲覧できるようにする",
        "Please ensure the WiFi network is working properly.": "WiFiネットワークが正常に動作していることをご確認ください。",
        "Edit akubela Smart Locks": "akubelaスマートロックの編集",
        "Upgraded Successfully!": "アップグレード成功！",
        "Upgraded Failed!": "アップグレード失敗！",
        "Editing...": "編集中...",
        "Edited successfully!": "編集完了！",
        "Edited Failed!": "編集失敗！",
        "Downloading video...": "ビデオをダウンロード中...",
        "All Locks": "すべてのロック",
        "Select Locks": "ロックを選択",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "akubelaスマートロックがネットワークに接続されると、{0}桁のPINコードが使用できます。同期後、PINコードが有効になるまで少し時間がかかる場合がありますのでご注意ください。",
        "Please at least select a door or a lock.": "ドアまたはロックを少なくとも1つ選択してください。",
        "This lock has already been added to your apartment.": "このロックはすでにあなたの部屋に追加されています。",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "このロックはすでに別の部屋に追加されています。サービスプロバイダーにご連絡ください。",
        "LockBody Version": "ロック本体バージョン",
        "Two-factor Authentication": "ダブル認証",
        "Monitoring Scope": "監視範囲",
        "Stay Duration": "滞在時間",
        "Volume Settings": "音量設定",
        "get card list for lock error": "ロックのカードリスト取得エラー",
        "get card list parse fail": "カードリストの解析に失敗しました",
        "get pin list for lock error": "ロック用PINリストの取得エラー",
        "get pin list parse fail": "PINリストの解析に失敗しました",
        "fingerprint code must be less than 2048 characters or empty.": "指紋コードは2048文字未満、または空でなければなりません。",
        "Personnel not in office.": "担当者はオフィスにいません。",
        "customize form fail.": "カスタムフォームの作成に失敗しました。",
        "smart lock type error.": "スマートロックの種類エラーです。",
        "invalid client id or secret": "クライアントIDまたはシークレットが無効です",
        "invalid account or password": "アカウントまたはパスワードが無効です",
        "invalid access token": "アクセストークンが無効です",
        "invalid refresh token": "リフレッシュトークンが無効です",
        "no permission to access this project": "このプロジェクトへのアクセス権がありません",
        "Stay Alarm Time": "アラーム継続時間",
        "This function only support sl20 lock.": "この機能はsl20ロックのみ対応しています。",
        "Json marshal error.": "Jsonマーシャルエラー。",
        "Json unmarshal error.": "Jsonアンマーシャルエラー。",
        "Illegal request, not added within valid time.": "不正なリクエスト、正当な期間内に追加されていません。",
        "invalid nvr type": "NVRタイプが無効です",
        "project is empty": "プロジェクトが空です",
        "project type is invalid": "プロジェクトタイプが無効です",
        "owner is invalid": "所有者が無効です",
        "url is invalid": "URLが無効です",
        "password is invalid": "パスワードが無効です",
        "building is invalid": "建物が無効です",
        "fail to get data": "データ取得に失敗しました",
        "invalid allow pm view type": "許可されたPM表示タイプが無効です",
        "Data not exist.": "データが存在しません。",
        "cannot find community PrivateKey.": "コミュニティのプライベートキーが見つかりません。",
        "cannot find single PrivateKey.": "個別のプライベートキーが見つかりません。",
        "The third party not exist.": "第三者が存在しません。",
        "{0} and indoor monitors/guard phones": "{0}と室内モニター／管理電話",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0}と室内モニター／管理電話に呼出、応答なしの場合電話へ発信",
        "Indoor monitors/guard phones with {0} as backup": "室内モニター／管理電話に呼出、応答なしの場合{0}へ発信",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "室内モニター／管理電話に呼出、応答なしの場合{0}へ、その後電話へ発信",
        "{0} Intercom Feature": "{0}インターホン機能",
        "Capture on {0}": "{0}でキャプチャ",
        "{0} Intercom Feature is not activated or has expired.": "{0}インターホン機能が有効化されていないか、期限切れです。",
        "fingerprint code must be equal 1620 characters or empty.": "指紋コードは1620文字であるか、空でなければなりません。",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "アップグレードを成功させるために、ロックのバッテリー残量が40％以上であることを確認してください。",
        "Automatic Locking Time": "自動施錠時間",
        "WiFi Keep-Alive": "WiFiキープアライブ",
        "WiFi Setting": "WiFi設定",
        "Connecting the network...": "ネットワークに接続中...",
        "Set successfully!": "設定が完了しました！",
        "The offline code can be used even if the lock is not connected to WiFi.": "ロックがWiFiに接続されていない場合でも、オフラインコードは使用できます。",
        "Enabling this feature will increase the lock\'s power consumption.": "この機能を有効にすると、ロックの消費電力が増加します。",
        "Each offline code can only be used once.": "オフラインコードは各1回のみ使用可能です。",
        "Receiver Info": "受信者情報",
        "log id": "ログインID",
        "Create HW SN Config Empty SN.": "Huawei SN設定でSNが空です。",
        "The SN": "シリアル番号",
        "SN can contain up to 32 characters.": "SNは最大32文字まで入力できます。",
        "Check HW SN Not Found.": "Huawei SNが見つかりません。",
        "the end user not found": "エンドユーザーが見つかりません",
        "Family Call": "家族通話",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "アップグレード中はロック関連の機能は一時的に利用できなくなります。",
        "8-digit PIN code starting with \"9\" is invalid!": "「9」で始まる8桁のPINコードは無効です！",
        "Lock name length must be between 1 and 50": "ロック名の長さは1文字以上50文字以下でなければなりません。",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "固定電話サービスを利用する人数は、{0}インターホンサービスを利用する人数を超えてはなりません。",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "固定電話サービスを利用している管理者の数は、{0}インターホンサービスを利用している管理者の数を超えてはなりません。",
        "charge type": "料金種別",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "固定電話サービスを利用している担当者の人数は、SmartPlusインターホンを利用している担当者の人数を超えてはなりません。",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "固定電話サービスを利用している管理者の人数は、SmartPlusインターホンを利用している管理者の人数を超えてはなりません。",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "リーダーはWiegandとRS485を同時に使用するよう設定できません。",
        "parameter error": "パラメータエラー",
        "community name already exist": "コミュニティ名はすでに存在します",
        "personnel app without intercom feature number": "インターホン機能のない人員アプリケーション番号",
        "check feature billing charge plan new error": "機能課金プラン新規エラーの確認",
        "subscription not found": "サブスクリプションが見つかりません",
        "System setting record not found.": "システム設定レコードが見つかりません。",
        "Smart home not enabled.": "スマートホームが有効になっていません。",
        "the apt call type value is invalid.": "apt通話方式の値が無効です。",
        "the ip call or sip call value is invalid.": "IP通話またはSIP通話の値が無効です。",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCodeは2～8桁の数字で、9で始まる8桁の数字または空白にはできません。",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCardはA-F0-9、16ビット未満または空白でなければなりません。",
        "owner cannot be empty.": "所有者は空にできません。",
        "creator cannot be empty.": "作成者は空にできません。",
        "the creator type value is invalid": "作成者タイプの値が無効です",
        "the IsCreateByPm value is invalid": "IsCreateByPmの値が無効です",
        "the pinCode already exist": "pinCodeはすでに存在します",
        "the rfCard already exist": "rfCardはすでに存在します",
        "license plate is invalid.": "ナンバープレートが無効です。",
        "owner info is invalid.": "所有者情報が無効です。",
        "uhf is invalid.": "uhfが無効です。",
        "time control is invalid.": "時間制御が無効です。",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "車両ナンバープレートの上限5枚に達しており、追加できません",
        "the plate already exist": "ナンバープレートはすでに存在します",
        "the uhf already exist": "uhfはすでに存在します",
        "empty community": "空のコミュニティ",
        "no find license Plate": "ナンバープレートが見つかりません",
        "IDAccess mode must be 0, 1, or 2.": "IDAccessモードは0、1、または2でなければなりません。",
        "Run field is required when mode is 1 or 2.": "モードが1または2の場合、Runフィールドが必須です。",
        "Serial field is required when mode is 2.": "モードが2の場合、Serialフィールドが必須です。",
        "the pin cannot be empty": "pinは空にできません",
        "the rfCard cannot be empty": "rfCardは空にできません",
        "the IDAccess already exist": "IDAccessはすでに存在します",
        "the resident cannot be empty": "居住者は空にできません",
        "the fingerprint cannot be empty": "指紋は空にできません",
        "the face cannot be empty": "顔画像は空にできません",
        "not found pin": "pinが見つかりません",
        "not found rfCard": "rfCardが見つかりません",
        "not found IDAccess": "IDAccessが見つかりません",
        "not found fingerprint": "指紋が見つかりません",
        "not found face": "顔画像が見つかりません",
        "face pic is invalid.": "顔写真が無効です。",
        "community build and room cannot be empty.": "コミュニティの建物や部屋は空にできません。",
        "device info mac cannot be empty.": "デバイス情報のMACは空にできません。",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "スケジューラータイプは0、1、2でなければならず、または時間形式が無効、またはdataflagが0～127に含まれていません。",
        "MAC address cannot be empty.": "MACアドレスは空にできません。",
        "MAC address 0C1105000000 is not allowed.": "MACアドレス0C1105000000は使用できません。",
        "MAC address must be 12 hexadecimal characters.": "MACアドレスは12桁の16進数でなければなりません。",
        "Scheduler type value is invalid.": "スケジューラータイプの値が無効です。",
        "parse is fail": "解析に失敗しました",
        "the fingerprint already exist": "指紋はすでに存在します",
        "the licensePlate cannot be empty": "ナンバープレートは空にできません",
        "the licensePlate already exist": "ナンバープレートはすでに存在します",
        "idaccess run must be 10 digit number or end with -K.": "idaccessのRunは10桁の数字または-Kで終わる必要があります。",
        "idaccess serial must be 9 digit number.": "idaccessのSerialは9桁の数字でなければなりません。",
        "relay not in 0-15": "リレーは0～15の範囲にありません",
        "security relay not in 0-3": "セキュリティリレーは0～3の範囲にありません",
        "file name is wrong": "ファイル名が違います",
        "access mode specified": "アクセスモード指定済み",
        "create community user accessmode failed.": "コミュニティユーザーのアクセスモード作成に失敗しました。",
        "delete community user accessmode failed.": "コミュニティユーザーのアクセスモード削除に失敗しました。",
        "Cannot delete building because it has associated users.": "関連するユーザーがいるため、建物を削除できません。",
        "Cannot delete building because it has associated Salto devices.": "関連するSaltoデバイスがあるため、建物を削除できません。",
        "community building not found": "コミュニティ建物が見つかりません",
        "Invalid Name Display": "無効な名前表示",
        "The Community does not exist.": "そのコミュニティは存在しません。",
        "Update CommunityIsInstallerKit Error.": "CommunityIsInstallerKitの更新エラー。",
        "Dis Not SupportCommunityCalls Error.": "代理店はコミュニティコールをサポートしていないエラー。",
        "Community Has Special Device, Not Allowed To Delete.": "コミュニティに特別なデバイスがあるため、削除できません。",
        "The project smart home switch must be disabled": "プロジェクトのスマートホームスイッチは無効にしてください",
        "There are ITec Locks in project": "プロジェクト内にITecロックがあります",
        "There are Salto Locks in project": "プロジェクト内にSaltoロックがあります",
        "There are Dormakaba Locks in project": "プロジェクト内にDormakabaロックがあります",
        "It is rent manager project": "これはrent managerプロジェクトです",
        "It is installer account": "これはインストーラーアカウントです",
        "contact preference type": "呼び出し優先タイプ",
        "Floor list is required when not all floors.": "すべてのフロアでない場合はフロアリストが必要です。",
        "Building floors list is required when all buildings.": "すべての建物の場合、建物フロアリストが必要です。",
        "Indoor monitor name is required.": "インドアモニター名は必須です。",
        "The primary account is not activated.": "プライマリーアカウントが有効化されていません。",
        "You can\'t create more family member accounts.": "これ以上ファミリーメンバーアカウントを作成できません。",
        "community user not found": "コミュニティユーザーが見つかりません",
        "community is empty": "コミュニティが空です",
        "the end user not master user": "エンドユーザーはマスターアカウントユーザーではありません",
        "the end user not member user": "エンドユーザーはサブアカウントユーザーではありません",
        "The email already exists and cannot be repeated": "このメールアドレスは既に存在し、重複できません",
        "The mobile Number already exists": "携帯番号はすでに存在します",
        "The room number format error.": "部屋番号の形式が間違っています。",
        "community not found": "コミュニティが見つかりません",
        "resident not found": "居住者が見つかりません",
        "installer not found": "インストーラーが見つかりません",
        "Operation Failed!": "操作が失敗しました！",
        "You don\'t have operate permission": "操作する権限がありません",
        "You cannot select Relay and Door at the same time": "リレーとドアを同時に選択できません",
        "user don\'t active": "ユーザーが有効になっていません",
        "User has expired": "ユーザーの有効期限が切れています",
        "timestamp must be within 3 minutes of current server time": "タイムスタンプは現在のサーバー時刻の3分以内でなければなりません",
        "cannot find single rf Card.": "単一のrf Cardが見つかりません。",
        "cannot find community rf Card.": "コミュニティのrf Cardが見つかりません。",
        "smartLock model": "スマートロックモデル",
        "the project does not open smart home": "本プロジェクトではスマートホームが有効になっていません",
        "php web server error": "phpウェブサーバーエラー",
        "Ins not found.": "Insが見つかりません。",
        "RentManage Unit Not Set.": "RentManageユニットが設定されていません。",
        "add audit log error": "監査ログの追加エラー",
        "check building in error": "建物の確認エラー",
        "Special devices cannot be deleted": "特殊なデバイスは削除できません",
        "the email is empty": "メールアドレスが空です",
        "the email format is incorrect": "メールアドレスの形式が正しくありません",
        "the mobile number is empty": "携帯番号が空です",
        "the mobile number format is incorrect": "携帯番号の形式が正しくありません",
        "Site not found": "プロジェクトが見つかりません",
        "User not found": "ユーザーが見つかりません",
        "invalid time format": "無効な時間形式",
        "ground floor type": "中間階タイプ",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "開始階範囲が間違っています。有効値は-10～-1、G0、G1、G2、1～128です。",
        "Building ID must be between 1 and 99.": "建物IDは1から99の間でなければなりません。",
        "Community building name": "コミュニティ建物名",
        "Building ID already exists in this community.": "このコミュニティにはすでにこの建物IDが存在します。",
        "building ID": "建物ID",
        "Community building not found.": "コミュニティ建物が見つかりません。",
        "Cannot delete building because it has associated devices.": "関連機器があるため、建物を削除できません。",
        "project is not valid": "プロジェクトが無効です",
        "Cannot delete building because it has associated salto devices.": "関連するsaltoデバイスがあるため、建物を削除できません。",
        "Cannot delete building because it has associated iTec devices.": "関連するiTecデバイスがあるため、建物を削除できません。",
        "Cannot delete building because it has associated dormakaba devices.": "関連するdormakabaデバイスがあるため、建物を削除できません。",
        "member limit num": "メンバー制限数",
        "Indoor Monitor No Set Error.": "室内モニターが設定されていません。",
        "The room not has indoor": "部屋に室内機がありません。",
        "check user in building error": "建物内のユーザー確認エラー",
        "The name specified is already in use.": "指定された名前はすでに使用されています。",
        "This timeblock overlaps with an existing one. Please adjust it.": "この時間帯は既存の時間帯と重複しています。調整してください。",
        "This door status changed. Please try again.": "このドアの状態が変更されました。もう一度お試しください。",
        "the lock can\'t bind this community": "このロックではこのコミュニティを紐付けることができません。",
        "The custom quantity limit has been exceeded!": "カスタム数量の上限を超えました。",
        "This time span overlaps with an existing one. Please adjust it.": "この時間範囲は既存のものと重複しています。調整してください。",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "この一度限りのスケジュールは、既存の一度限りのスケジュールの有効時間と重複しています。調整してください。",
        "Operation Failed. Please try again.": "操作に失敗しました。もう一度お試しください。",
        "The image is not a front view.": "この画像は正面図ではありません。",
        "A mask was detected.": "マスクが検出されました。",
        "The image resolution is too low.": "画像の解像度が低すぎます。",
        "No face was detected.": "顔が検出されませんでした。",
        "The file size is too large.": "ファイルのサイズが大きすぎます。",
        "The face in the image is too large.": "画像の中の顔が大きすぎます。",
        "The face in the image is too small.": "画像の中の顔が小さすぎます。",
        "Multiple faces detected.": "複数の顔が検出されました。",
        "The face is not clear enough.": "顔がはっきりしていません。",
        "Face detection failed.": "顔検出に失敗しました。",
        "Please enter a value between 1 and 9999": "1から9999の間の値を入力してください。",
        "Please select which input your door sensor is connected to.": "ドアセンサーが接続されている入力を選択してください。",
        "Add temp key failed, please try it again": "一時的なキーの追加に失敗しました。もう一度お試しください。",
        "Dis Not Support Dynamic QRCode Error.": "代理店は動的QRコードをサポートしていません。",
        "QR code not exist": "QRコードが存在しません",
        "The temp key has expired.": "一時的なキーの有効期限が切れました。",
        "The device is not in the office": "このデバイスはオフィス内にありません。",
        "The device is already assigned.": "デバイスはすでに割り当てられています。",
        "The device cannot be assigned to any user.": "このデバイスはどのユーザーにも割り当てることができません。",
        "You cannot select an option with fewer users than the current project members.": "現在のプロジェクトメンバー数より少ないユーザー数のオプションは選択できません。",
        "File check failed. Please download the latest template and try again.": "ファイルチェックに失敗しました。最新のテンプレートをダウンロードして、再度お試しください。",
        "Dynamic QR Code not active.": "ダイナミックQRコードは有効ではありません。",
        "Dynamic QR Code not enable.": "ダイナミックQRコードは有効になっていません。",
        "{0} not found.": "{0}が見つかりません。",
        "Tier charge plan": "階段別料金プラン",
        "Feature billing charge plan new": "新機能課金プラン",
        "Feature billing gradient charge plan": "機能課金グラデーション料金プラン",
        "The exit time cannot be earlier than the entry time.": "退出時刻は入場時刻より前にはできません。",
        "User Name or Password": "ユーザー名またはパスワード",
        "You can only link up to 5 sites.": "リンクできるサイトは最大5件までです。",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "このナンバープレートは既に居住者に登録されているため、ブロックリストに追加できません。",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "このナンバープレートはブロックリストに登録されているため、車両として登録できません。",
        "Elevator not configured in company access floor.": "会社のアクセスフロアにエレベーターが設定されていません。",
        "the device is not in the office": "このデバイスはオフィス内にありません。",
        "A maximum of 1000 data items can be imported": "最大1000件のデータをインポートできます。",
        "Exit time cannot be later than the current time.": "退出時刻は現在時刻より遅くできません。",
        "You can only import a file at a time in the current parking lot.": "現在の駐車場では、一度にインポートできるファイルは1つだけです。",
        "The license plate is already in the blocklist.": "そのナンバープレートは既にブロックリストに登録されています。",
        "Building name too long.": "建物名が長すぎます。",
        "Unlock failed. Permission denied by user.": "解錠に失敗しました。ユーザーにより許可が拒否されました。",
        "Please remove the sensor device(s) before disabling this feature.": "この機能を無効にする前に、センサーデバイスを削除してください。",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "操作に失敗しました。このユーザーは1日の15件の記録上限を超えています。",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "プロジェクトごとに追加できる共用デバイスは最大{0}台です。さらに追加する場合は、Akuvoxテクニカルサポート（support{'@'}akuvox.com）までお問い合わせください。",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "プロジェクトごとに追加できるスタッフアカウントは最大{0}件です。さらに追加する場合は、Akuvoxテクニカルサポート（support{'@'}akuvox.com）までお問い合わせください。",
        "cancel": "キャンセル",
        "Battery Level": "バッテリー残量",


    }
};
